import { NgModule } from '@angular/core';
import { Component, OnInit, Inject, NgZone } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

export interface AlertaSimples {
    textoAlerta: string;
    iconAlerta: string;
    tituloAlerta: string;
}

@Component({
    selector: 'alerta-simples',
    templateUrl: './alerta-simples.html',
    styleUrls: ['./alerta-simples.css']
  })
  export class AlertaSimplesDialog {
  
    constructor(
      private ngZone: NgZone, public dialogRef: MatDialogRef<AlertaSimplesDialog>,
      @Inject(MAT_DIALOG_DATA) public data: AlertaSimples) {}
  
    onInit(){
      if(this.data.tituloAlerta == undefined){
        this.data.tituloAlerta = "Aviso";
      }
    }
    onNoClick(): void {
      console.log("clicou");
      this.ngZone.run(() => {
        this.dialogRef.close(true);
      });
     
    }
  
}